var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 214.92 224.88",
    style: {
      enableBackground: "new 0 0 214.92 224.88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.2;fill:#E0E0E0;}\n\t.st1{fill:#FF0017;}\n\t.st2{fill:#F8AD3B;}\n\t.st3{fill:#212121;}\n\t.st4{fill:#5F11EA;}\n\t.st5{fill:#3E2466;}\n\t.st6{fill:none;}\n\t.st7{fill:#EFE0D0;}\n\t.st8{fill:#B5AAA0;}\n\t.st9{opacity:0.8;fill:#212121;}\n\t.st10{fill:none;stroke:#212121;stroke-width:4.4689;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#212121;stroke-width:2.4428;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.03,49.67c72.65-42.24,149.9-44.93,172.53-6c14.38,24.73,1.83,55.36-12.56,76.94 c-19.35,29.01-50.05,60.12-85.07,68.06c-30.58,6.93-66.56,0.97-88.89-22.25C4.5,148.18-3.41,122.25,1.37,97.36 C4.87,79.18,14.84,61.99,36.03,49.67z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.17,175.33c-0.55,16.95-3.42,21.45-5.65,11.24c-2.84-13.06-4.53,9.83-7,24.17 c-3.96,23-10.91,14.53-12.92-1.26c-6.32-49.7-17.86,20.07-19.21-21.98c-0.16-5.09-1.05-15.84-0.6-23.44 c0.08-1.3,0.17-2.57,0.28-3.79c0-0.07,0.01-0.14,0.02-0.21l2.97-8.59h38.79l2.93,8.48c0.03,0.17,0.04,0.34,0.05,0.51 C130.24,165.42,130.33,170.41,130.17,175.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M124.46,165.03c-0.01,0.13-0.01,0.25-0.02,0.37c-0.44,9.81-2.56,12.34-4.21,6.33 c-2.13-7.78-3.39,5.87-5.24,14.42c-2.97,13.71-8.17,8.67-9.67-0.75c-4.74-29.64-13.37,11.97-14.39-13.11 c-0.07-1.61-0.28-4.16-0.42-6.87c-0.12-2.42-0.18-4.97-0.02-7.11c0.2-2.74,0.57-5.27,0.84-6.84h32.17 C124.39,155.94,124.65,160.53,124.46,165.03z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M129.85,160.14c0,0.11-0.01,0.22-0.02,0.32c-0.22,1.87-7.51,6.12-22.37,6.12s-22.3-4.36-22.39-6.31 c-0.01-0.04-0.01-0.09-0.01-0.13l0.03-0.08l2.97-8.59h38.79l2.93,8.48L129.85,160.14z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M97.91,31.73c-8.05-2.13-27.36-6.78-32.79-10.76c-5.43-3.98,0.01-3.17,0-4.26 c0.01-0.22-2.96-0.32-6.33-0.06c-0.01,0.01-0.03,0.01-0.04,0.01c-3.4,0.26-7.2,0.9-8.75,2.17c0,0-0.01-0.01-0.01,0.01 c-1.12,0.91-1.06,2.16,1.18,3.83c3.52,3.21,14.41,7.15,22.1,9.63L97.91,31.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M51.16,22.67c0.89,0.81,2.24,1.66,3.89,2.53c3.57-1.78,7.97-2.76,11.54-3.3c-0.56-0.31-1.06-0.62-1.48-0.93 c-5.43-3.98,0.01-3.17,0-4.26c0.01-0.22-2.96-0.32-6.33-0.06c-0.01,0.01-0.03,0.01-0.04,0.01c-3.4,0.26-7.2,0.9-8.75,2.17 c-0.01,0-0.01,0-0.01,0.01C48.86,19.75,48.93,20.99,51.16,22.67z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M102.48,17.97l-0.28,13.7c-3.32-3.05-14.23-10.7-28.35-13.52c4.98-2.08,9.92-5.28,10.37-13.85 C89.86,7.32,95.57,11.9,102.48,17.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M84.21,4.3c-0.46,8.57-5.4,11.77-10.37,13.85c-3.32-0.66-6.83-1.06-10.45-1.06c-1.54,0-3.08,0.09-4.6,0.27 c-2.89,0.32-5.72,0.99-8.42,2.04c-0.12,0.05-0.25,0.09-0.37,0.14c-0.17,0.07-0.33,0.14-0.5,0.21c-0.15,0.06-0.2,0.03-0.18-0.1 c1.85-7.48,4.48-19.15,16.55-19.62C72.72-0.24,78.43,1.21,84.21,4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M102.48,17.97C88.51,5.69,79.42-0.5,65.85,0.03C53.79,0.5,51.15,12.16,49.31,19.64 c-0.03,0.13,0.02,0.16,0.18,0.1c0.17-0.07,0.34-0.14,0.51-0.21c0.12-0.05,0.25-0.1,0.38-0.14c2.69-1.04,5.52-1.71,8.42-2.04 c1.52-0.18,3.06-0.26,4.6-0.26c19.03,0.02,34.7,10.81,38.8,14.57"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M142.28,32.21c7.43-2.47,17.95-6.38,21.35-9.58c2.16-1.67,2.21-2.91,1.14-3.81c0-0.01-0.01-0.01-0.01-0.01 c-1.5-1.27-5.17-1.9-8.45-2.16c-0.01,0-0.03,0-0.04-0.01c-3.25-0.26-6.12-0.15-6.12,0.06c-0.01,1.08,5.24,0.27,0,4.23 c-5.25,3.97-23.89,8.59-31.67,10.71L142.28,32.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M163.63,22.64c-0.86,0.8-2.16,1.65-3.76,2.51c-3.45-1.77-7.69-2.75-11.15-3.28 c0.55-0.31,1.03-0.62,1.43-0.92c5.24-3.96-0.01-3.16,0-4.23c-0.01-0.21,2.86-0.32,6.12-0.06c0.01,0.01,0.03,0.01,0.04,0.01 c3.29,0.26,6.95,0.89,8.45,2.16c0.01,0,0.01,0,0.01,0.01C165.85,19.73,165.79,20.97,163.63,22.64z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M165.42,19.93c0.02,0.13-0.02,0.16-0.17,0.1c-0.16-0.07-0.33-0.14-0.49-0.2c-0.12-0.05-0.24-0.1-0.37-0.15 c-2.29-0.91-4.68-1.54-7.13-1.9c-1.74-6.2-6.03-12.75-10.28-17.38c0.81-0.02,1.62-0.02,2.46,0.02 C161.1,0.88,163.64,12.49,165.42,19.93z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M157.26,17.78c-0.33-0.05-0.67-0.09-1-0.13c-1.47-0.17-2.95-0.26-4.44-0.26 c-18.39,0.02-33.52,10.75-37.48,14.49l-0.28-13.61C126.7,6.83,135.2,0.71,146.98,0.4C151.23,5.03,155.52,11.58,157.26,17.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M114.34,31.89c3.96-3.75,19.1-14.47,37.48-14.49c1.49,0,2.97,0.08,4.44,0.26c2.8,0.32,5.53,0.99,8.13,2.02 c0.12,0.05,0.24,0.1,0.36,0.14c0.16,0.07,0.33,0.14,0.49,0.21c0.15,0.06,0.2,0.03,0.17-0.1c-1.78-7.44-4.32-19.04-15.98-19.51 c-13.11-0.52-21.88,5.63-35.38,17.85"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M106.2,28.08c-1.72,0.53-1.91,1.21-1.28,1.91l-2.83-0.05c-0.11-1-0.29-2.5-0.61-4.76 c-0.24-1.59-0.37-3.83-0.41-6.74c-0.02-1.6,1.42-2.39,3.34-2.82c1.55-0.33,3.87-0.47,5.99-0.2 C110.43,19.63,112.24,26.2,106.2,28.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M115.66,18.9c0.02,1.97-0.13,3.92-0.44,5.88l-0.77,5.38l-9.54-0.18c-0.63-0.7-0.44-1.38,1.28-1.91 c6.05-1.87,4.23-8.44,4.21-12.67C113.18,15.75,115.64,16.77,115.66,18.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "107.46,62.99 107.46,28.69 17.61,46.8 17.61,73.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "107.46,62.99 107.46,28.69 197.31,46.8 197.31,73.49  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "188.72,140.91 188.72,72.48 107.46,63.02 107.46,156.24  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "26.19,140.91 26.19,72.48 107.46,63.02 107.46,156.24  "
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "17.61,73.55 26.14,75.1 26.14,76.71 107.49,68.04 107.46,62.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "197.31,73.49 188.73,75.11 188.73,76.71 107.43,68.04 107.46,62.99  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M102.06,29.59c-0.11-1-0.25-2.15-0.57-4.42c-0.24-1.59-0.37-3.83-0.41-6.75c-0.02-1.59,1.42-2.39,3.34-2.82 c3.57-0.78,11.21-0.48,11.25,3.29c0.02,1.97-0.13,3.93-0.44,5.88l-0.76,5.38"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M56.62,125.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M56.62,69.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M75,148.89"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M161.08,124.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M161.08,71.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M142.7,149.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M142.7,68.89"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M93.65,31.53c-5.35,1.02-14.24,3.34-14.24,3.34c-0.73,0.43-1.41,0.87-2.07,1.35 c-3.84,2.73-6.37,6.24-7.38,12.44c-2.76,16.85,1.17,37.54,0.23,36.26c-10.28-14.37-10.37-12.05-19.24-0.05 c-0.39,0.49-1.06-22.81,0.07-35.39c0.36-4.08,1.91-7.25,4.02-9.7c6.15-7.19,17.05-8.3,17.05-8.3c3.94-0.84,5.12-0.46,16.54-1.33 C88.7,30.14,93.65,31.53,93.65,31.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M164.9,84.54c-8.87-12-8.96-14.32-19.24,0.05c-0.94,1.27,3-19.41,0.23-36.26c-0.89-5.4-3.03-11.37-6.69-12.64 c-3.66-1.27-19.15-4.46-19.15-4.46l6.41-1.72l17.3,1.63c0,0,19.64,2.01,21.07,18.01C165.96,61.73,165.3,85.02,164.9,84.54z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st6",
    points: "139.92,66.86 107.46,63.84 107.46,156.3 151.77,147.94  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M161.12,39.57"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageSuccess);
export default __webpack_public_path__ + "static/media/image-success.f39876ca83bf89d5ddd0093bd245b376.svg";
export { ForwardRef as ReactComponent };